import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, finalIncludes, trackCheckout } from '../data/offer';
const noMore = ['No more Sunday nights searching for sequences that work', 'No more classes that feel rushed or improvised', 'No more athletes losing motivation because sessions feel repetitive', 'No more weekends spent planning instead of living', 'No more walking in wishing you’d prepared more'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-base relative overflow-hidden" data-id="element-92" data-mp="h6n8dbv7ihto">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93" data-mp="vui5r5k5tad3">
        <div className="text-center mb-16" data-id="element-94" data-mp="vu8ab2gcib00">
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-8 leading-tight text-ink" data-id="element-95" data-mp="qvx5550zwoo4">
            Next Monday you could keep building your classes from scratch...
            <br data-id="element-96" data-mp="14t3n4xdwajca" />
            <span className="text-brand" data-id="element-97" data-mp="zwmx1xn4xuwk">
              Or you could walk into the gym with everything ready — from today.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-cream-light p-8 rounded-2xl border border-silver-light" data-id="element-98" data-mp="2c6hgc7ianjc3">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-99" data-mp="2m1swmu9coyly">
                <span className="text-brand mt-1" aria-hidden="true" data-id="element-100" data-mp="2r1npv4glm0a6">
                  ▸
                </span>
                <span className="text-graphite" data-id="element-101" data-mp="2v428pok9p01g">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-ink mb-2" data-id="element-102" data-mp="301txwatj281y">
            Ninja Coach Ready™ doesn&apos;t make you a better coach.
          </p>
          <p className="text-2xl font-bold text-brand mb-6" data-id="element-103" data-mp="34tu24fgmrn4c">You&apos;re already a great coach.</p>
          <p className="text-xl text-graphite mb-16" data-id="element-104" data-mp="39rvphcl3a8lm">
            What Ninja Coach Ready does is give you the time and tools to make that visible in every
            class you teach.
          </p>
        </div>
        <div className="bg-white border-2 border-brand/30 rounded-3xl p-8 md:p-12 shadow-[0_20px_50px_-34px_rgba(27,26,25,0.4)]" data-id="element-105" data-mp="3itd40qium287">
          <h3 className="text-2xl font-bold text-ink mb-6 text-center border-b border-silver-light pb-6" data-id="element-106" data-mp="1epih5hjdplf2">
            Everything that&apos;s included:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107" data-mp="1shyfw658yxa6">
            {finalIncludes.map(item => <div key={item} className="flex items-start gap-3" data-id="element-108" data-mp="1no3u8x63088g">
                <Check size={18} className="text-brand shrink-0 mt-0.5" aria-hidden="true" data-id="element-109" data-mp="22d9rwgp9tqe8" />
                <span className="text-sm text-graphite" data-id="element-110" data-mp="1xeyjmaemjny4">{item}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-111" data-mp="2beq3grrtnyk1">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-silver-light italic text-graphite text-lg" data-id="element-112" data-mp="27e7bmxpxishu">
              &ldquo;The best time to have this coaching system was before your first class.
              <br data-id="element-113" data-mp="d0enpz6xz0qb" />
              <span className="text-brand font-bold not-italic" data-id="element-114" data-mp="d0y5nfwldp4c">
                The second-best time is today.
              </span>
              &rdquo;
            </div>
            <p className="text-xl font-display font-extrabold text-ink mb-2" data-id="element-115" data-mp="6y31w5ntoi9o">
              🏆 Ninja Coach Ready™
            </p>
            <p className="text-sm text-graphite-light mb-8" data-id="element-116" data-mp="3parfr02oxo3f">
              150 Ninja classes ready to teach, created to help coaches plan less, train with
              confidence, and keep every session fresh.
            </p>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-xl py-5 md:py-6 px-8 md:px-12 mb-6" data-id="element-117" data-mp="3ffhe4dg7fiq6">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-graphite-light" data-id="element-118" data-mp="3bcba7cgke3mv">
              <span data-id="element-119" data-mp="14mmuoagh9h7j">✅ 7-day money-back guarantee</span>
              <span data-id="element-120" data-mp="19k4vfdkccq4g">✅ Secure payment</span>
              <span data-id="element-121" data-mp="19j3i12furrjk">✅ Immediate access</span>
              <span data-id="element-122" data-mp="35njd8hwerfkp">✅ Pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}